// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"f176811c","376":"3bfcae3c"}[chunkId] + ".chunk.js";
};